module.exports = __webpack_public_path__ + "static/media/receta-13.319a23b9.png";